// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ObserveBase_wrapper_3IJYR","block":"ObserveBase_block_10Gx4","description":"ObserveBase_description_2HdaE","items":"ObserveBase_items_3VWKW"};